import { render, staticRenderFns } from "./customElementRenderer.vue?vue&type=template&id=1da2ce5a&"
import script from "./customElementRenderer.vue?vue&type=script&lang=js&"
export * from "./customElementRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports